module.exports = __webpack_public_path__ + "static/og-image-default-2b4ff93e985fd54c81f16bed9cbffc56.jpg";